import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ApiService from '../../../services/apiService';
import MapViewMixin from '@/components/core/dtwin/map/viewMixin';
import { mapState } from 'vuex';
export default {
  name: 'ViewISAssetMgmtMap',
  mixins: [MapViewMixin],
  data: function data() {
    return {
      selectedAccounts: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), {}, {
    requestFilter: function requestFilter() {
      if (this.selectedAccounts.length === 0) {
        return [];
      }

      return [{
        type: 'tenantIds',
        ids: this.selectedAccounts
      }];
    }
  }),
  watch: {
    selectedAccounts: function selectedAccounts() {
      this.$refs.mapInstance.debouncedRequestClusterRequest();
    }
  },
  mounted: function mounted() {
    this.loadInitialData();
  },
  methods: {
    fetchTwinData: function fetchTwinData() {
      var _this = this;

      this.loadTree();
      return ApiService.isAssetMgmtFetchGeoMetaInfos(this, this.requestFilter).then(function (data) {
        _this.stateKeys = data.keyList;
        _this.twinTags = data.tagList;
        _this.floorList = data.floorList;
      }).catch(function (error) {
        console.error('Error loading map-twin-state-keys', error);
      });
    },
    resetDefaults: function resetDefaults() {
      this.selectedStateKey = null;
      this.selectedTwinTag = null;
      this.gradientPolygonColours = false;
      this.selectedAccounts = [];
    },
    getClusterContent: function getClusterContent(cluster, bounds) {
      var _this2 = this;

      if (!cluster) {
        this.selectedCluster = {};
        return;
      }

      ApiService.isAssetMgmtGetGeoClusterContent(this, cluster.id, this.indoorFloorDtwinId, [[bounds['_ne'].lng, bounds['_ne'].lat], [bounds['_sw'].lng, bounds['_sw'].lat]], null, // search-item
      this.selectedTwinTag, this.requestFilter, // filters
      [] // options
      ).then(function (data) {
        _this2.selectedCluster = _objectSpread(_objectSpread({}, cluster), {}, {
          items: data.dtwins
        });
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      });
    },
    loadTree: function loadTree() {
      var _this3 = this;

      var bounds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      this.$store.state.app.load = 10;
      this.$store.state.app.loading = true;
      return ApiService.isAssetMgmtFetchGeoClusters(this, this.indoorFloorDtwinId, bounds, null, // search-item
      this.selectedTwinTag, this.requestFilter, // filters
      [], // options
      this.selectedStateKey).then(function (data) {
        _this3.calculateBoundingBox(data);

        _this3.markerItems = data.dtwins;
      }).catch(function (error) {
        console.error('Error loading map-twin-clusters', error);
      }).finally(function () {
        _this3.$store.state.app.loading = false;
      });
    }
  }
};